export default __webpack_public_path__ + "static/inovationArticle-8a2d63fd697315c8532b3a9c28b42186.png";